import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const WorkHistory = ({ data = {}, basicActive = "" }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="card mb-4">
        <div className="card-body">
          <Row className="work-history">
            <Col sm={3}>
              <div className="mb-0 profile_subsection-dim_title ">
                {t("cardViewText.workHistory")}
              </div>
            </Col>
            <Col sm={9} className="scroll-area">
              {data?.work_history ? (
                <ul className="mb-0">
                  <li className="profile_subsection-body">
                    {data?.work_history}
                  </li>
                </ul>
              ) : (
                <p className="text-center mb-0">Unknown</p>
              )}
            </Col>
          </Row>
          <hr />
          <Row>
            <Col sm={3}>
              <div className="mb-0 profile_subsection-dim_title">
                {t("cardViewText.education")}
              </div>
            </Col>
            <Col sm={9}>
              {data?.education_history ? (
                <ul className="mb-0">
                  <li className="profile_subsection-body">
                    {data?.education_history}
                  </li>
                </ul>
              ) : (
                <p className="text-center mb-0">Unknown</p>
              )}
            </Col>
          </Row>
          {basicActive === "Candidate Information" && (
            <>
              <hr />
              <Row>
                <Col sm={3}>
                  <div className="mb-0 profile_subsection-dim_title">{t("cardViewText.bio")}</div>
                </Col>
                <Col sm={9}>
                  {data?.bio ? (
                    <ul className="mb-0">
                      <li className="profile_subsection-body">{data?.bio}</li>
                    </ul>
                  ) : (
                    <p className="text-center mb-0">Unknown</p>
                  )}
                </Col>
              </Row>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default WorkHistory;
